import { createContext } from 'react';
import { ProviderAvailability } from '@types';
import { GroupedAvailabilitiesByTimeBlock } from './utils';

type Props = {
  availabilities: ProviderAvailability[];
  groupedAvailabilitiesByTimeBlock: GroupedAvailabilitiesByTimeBlock;
};

export const AppointmentTimePreferenceContext = createContext<
  Props | undefined
>(undefined);
